import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import EventOptions from '../../Common/EventOptions/EventOptions';
import NumericalOptions from '../../Common/NumericalOptions/NumericalOptions';
import Help from '../../Common/Help/Help';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import TextareaCount from '../../Common/TextareaCount/TextareaCount';
import './Details.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Details extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            videos: [],
            isMTIOpen: false
        };
    }

    componentDidMount() {
        this.getAdminVideos();
    }

    componentWillReceiveProps(props) {
        if(props.isCloseMTI) {
            this.setState({
                isMTIOpen: false
            });
        }
    }

    getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = videosResponse.data;
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }

    renderHelpStream = () => {
        let event_type = this.props.event.details.event_type;
        if (event_type === 'Video On Demand' || event_type === 'Live Stream' || event_type === 'Scheduled Content') {
            return (
                <Help help={strings.helpVOD} />
            )
        } else {
            return null;
        }
    };

    toggleMTI = () => {
        this.setState({
            isMTIOpen: !this.state.isMTIOpen,
        });
    };
    
    renderMTIShows = () => {
        const mtiShows = this.props.event.details.existingMitShows;
        let mtiShowsFiltered = this.props.event.details.existingMitShows;
        if (this.props.event.details.event_type === 'Video On Demand') {
            mtiShowsFiltered = mtiShows.filter((show) => show.can_video_on_demand);
        }
        if (this.props.event.details.event_type === 'Live Stream' || this.props.event.details.event_type === 'Scheduled Content') {
            mtiShowsFiltered = mtiShows.filter((show) => show.can_live_stream);
        }
        return (
            <React.Fragment>
                {mtiShowsFiltered.map((show, i) => (
                    <div key={i} className="col-12 col-lg-3 col-md-4 col-sm-6">
                        <div className="showtix-event-details d-flex">
                            <div className="showtix-event-details__poster">
                                <img src={show.poster_graphic_url} alt="poster" />
                            </div>
                            <div className="showtix-event-details__info">
                                <p className="showtix-event-details__name">{show.name}</p>
                                <p
                                    className="showtix-event-details__link"
                                    onClick={() => this.props.populateEventDetails(show.id)}
                                    >
                                    {strings.selectShow}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            </React.Fragment>    
        );
    }

    /* renderMTI = () => {
        return (
            <div className={"showtix-mti " + (this.state.isMTIOpen ? 'is-active' : '')}>
                <div className="row">
                    <div className="col-12 col-lg-9">
                        <label className="showtix-label" htmlFor="venue-name">{strings.search}</label>

                        <div className="row">
                            <div className="col-12 col-lg-8">
                                <div className="row">
                                    <div className="col-12 col-md-9">
                                        <div className="showtix-form__group">
                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    type="text"
                                                    object="details"
                                                    name="searchTerm"
                                                    value={this.props.event.details.searchTerm}
                                                    onChange={this.props.handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3">
                                        <div className="showtix-form__group">
                                            <button
                                                className="showtix-button showtix-background__primary-1"
                                                type="submit"
                                                onClick={this.props.handleSearch}
                                            >
                                                <span>{strings.searchButton}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.event.details.existingMitShows.length > 0 &&
                            <div>
                                <div className="row">
                                    {this.renderMTIShows()}
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                            onClick={this.props.clearSelectedShow}
                                        >
                                            {strings.cancelSelectedShow}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                        </div>

                    <div className="col-12 col-lg-3">
                        { strings.helpSearch &&
                            <Help help={strings.helpSearch} />
                        }
                        { strings.helpSearch2 &&
                            <Help help={strings.helpSearch2} />
                        }
                    </div>
                </div>
                <hr className="showtix-event-details__hr" />
            </div>
        );
    } */

    renderMTI = () => {
        if (this.props.event.details.licensing_house === 'MTI') {
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-12 col-lg-9">
                            <label className="showtix-label" htmlFor="license_access_code">MTI Access Code</label>
    
                            <div className="row">
                                <div className="col-12 col-lg-8">
                                    <div className="row">
                                        <div className="col-12 col-md-9">
                                            <div className={"showtix-form__group " + (this.props.validation.details.license_access_code.valid === false ? 'showtix-form__error' : '')}>
                                                <div className="showtix-form__input">
                                                    <input
                                                        className="showtix-input"
                                                        type="text"
                                                        id="license_access_code"
                                                        object="details"
                                                        name="license_access_code"
                                                        value={this.props.event.details.license_access_code}
                                                        onChange={this.props.handleChange}
                                                    />
                                                </div>
                                                {!this.props.validation.details.license_access_code.valid &&
                                                    <div className=" showtix-note error">
                                                        {this.props.validation.details.license_access_code.msg}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <div className="showtix-form__group">
                                                <button
                                                    className="showtix-button showtix-background__primary-1"
                                                    type="submit"
                                                    onClick={() => this.props.handleMTIAccessCode()}
                                                >
                                                    <span>{strings.searchButton}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.props.event.details.existingMitShows.length > 0 &&
                                <div>
                                    <div className="row">
                                        {this.renderMTIShows()}
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <button
                                                className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                                onClick={this.props.clearSelectedShow}
                                            >
                                                {strings.cancelSelectedShow}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

    renderDPS = () => {
        if (this.props.event.details.licensing_house === 'DPS') {
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-12 col-lg-9">
                            <label className="showtix-label" htmlFor="license_access_code">
                                DPS Sales Order Number
                                <span id="tooltip-dps" className="showtix-tooltip">!</span>
                                <Tooltip placement="top" target="tooltip-dps">
                                    DPS Access codes always start with "SO_"
                                </Tooltip>
                            </label>
    
                            <div className="row">
                                <div className="col-12 col-lg-8">
                                    <div className="row">
                                        <div className="col-12 col-md-9">
                                            <div className={"showtix-form__group " + (this.props.validation.details.license_access_code.valid === false ? 'showtix-form__error' : '')}>
                                                <div className="showtix-form__input">
                                                    <input
                                                        className="showtix-input"
                                                        type="text"
                                                        id="license_access_code"
                                                        object="details"
                                                        name="license_access_code"
                                                        value={this.props.event.details.license_access_code}
                                                        onChange={this.props.handleChange}
                                                    />
                                                </div>
                                                {!this.props.validation.details.license_access_code.valid &&
                                                    <div className=" showtix-note error">
                                                        {this.props.validation.details.license_access_code.msg}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {/* }
                                        <div className="col-12 col-md-3">
                                            <div className="showtix-form__group">
                                                <button
                                                    className="showtix-button showtix-background__primary-1"
                                                    type="submit"
                                                    onClick={() => this.props.handleDPS()}
                                                >
                                                    <span>{strings.searchButton}</span>
                                                </button>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

    renderConcord = () => {
        if (this.props.event.details.licensing_house === 'CT') {
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-12 col-lg-9">
                            <label className="showtix-label" htmlFor="license_access_code">Concord License Number</label>
    
                            <div className="row">
                                <div className="col-12 col-lg-8">
                                    <div className="row">
                                        <div className="col-12 col-md-9">
                                            <div className={"showtix-form__group " + (this.props.validation.details.license_access_code.valid === false ? 'showtix-form__error' : '')}>
                                                <div className="showtix-form__input">
                                                    <input
                                                        className="showtix-input"
                                                        type="text"
                                                        id="license_access_code"
                                                        object="details"
                                                        name="license_access_code"
                                                        value={this.props.event.details.license_access_code}
                                                        onChange={this.props.handleChange}
                                                    />
                                                </div>
                                                {!this.props.validation.details.license_access_code.valid &&
                                                    <div className=" showtix-note error">
                                                        {this.props.validation.details.license_access_code.msg}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

    renderOthers = () => {
        if (!this.props.event.details.licensing_house || this.props.event.details.licensing_house === 'Other/Multiple/Royalty Free') {
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-12 col-lg-9">
                            <label className="showtix-label" htmlFor="license_access_code">Please describe licensing</label>
    
                            <div className="row">
                                <div className="col-12 col-lg-8">
                                    <div className="row">
                                        <div className="col-12 col-md-9">
                                            <div className={"showtix-form__group " + (this.props.validation.details.license_access_code.valid === false ? 'showtix-form__error' : '')}>
                                                <div className="showtix-form__input">
                                                    <input
                                                        className="showtix-input"
                                                        type="text"
                                                        id="license_access_code"
                                                        object="details"
                                                        name="license_access_code"
                                                        value={this.props.event.details.license_access_code}
                                                        onChange={this.props.handleChange}
                                                    />
                                                </div>
                                                {!this.props.validation.details.license_access_code.valid &&
                                                    <div className=" showtix-note error">
                                                        {this.props.validation.details.license_access_code.msg}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

    renderMusicRights = () => {
        if (this.props.event.details.licensing_house === 'MusicRights') {
            let message = {
                title: 'Please note:',
                content: '<p>ShowTix4U will automatically deduct the 10% royalty from ticket proceeds.</p>',
            }
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-12 col-lg-9">
                            <Help help={message} />
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

    renderEventType = () => {
        return (
            <div className="showtix-form__group">
                <label className="showtix-label" htmlFor="event_type">{strings.eventType}
                    <span id="tooltip-eventType" className="showtix-tooltip">!</span>
                    <Tooltip placement="top" target="tooltip-eventType">
                        {strings.eventTypeTooltip}
                    </Tooltip>
                </label>

                <div className="showtix-form__select">
                    <select className="showtix-input"
                        object="details"
                        name="event_type"
                        id="event_type"
                        value={this.props.event.details.event_type}
                        onChange={this.props.handleChangeType}
                        disabled={this.props.event.isPublished}
                    >
                        <EventOptions />
                    </select>
                </div>
            </div>
        );
    }

    renderLicensingHouses = () => {
        if (!this.props.isEditMode) {
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="licensing_house">{strings.licensingHousesLabel}</label>
                                <div className="showtix-form__select">
                                    <select className="showtix-input"
                                        object="details"
                                        name="licensing_house"
                                        id="licensing_house"
                                        value={this.props.event.details.licensing_house}
                                        onChange={this.props.handleLicensingHouse}
                                    >
                                        {strings.licensingHouses.map((option) => (
                                            <option value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.renderMTI()}
                    {this.renderDPS()}
                    {this.renderConcord()}
                    {this.renderOthers()}
                    {this.renderMusicRights()}
                    <hr className="showtix-event-details__hr" />
                </React.Fragment>
            );
        }
    }

    renderEventTips = () => {
        if (this.props.event.details.event_type === 'Live Stream') {
            return (
                <Help help={strings.tipLiveStreaming} />
            )
        }
        if (this.props.event.details.event_type === 'Video On Demand') {
            return (
                <Help help={strings.tipVOD} />
            )
        }
        if (this.props.event.details.event_type === 'Scheduled Content') {
            return (
                <Help help={strings.tipScheduledContent} />
            )
        }
    }

    render() { 
        const videos = this.state.videos;
        let createEventUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
        if (videos.length > 0) {
            videos.forEach((video) => {
                if (video.title.includes('Creating New Event')) {
                    createEventUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
                }
            });
        }
        return (  
            <div className="showtix-section container">
                <h1>{strings.title}</h1>
                <div className="row">
                    <div className="col-12 col-md-6">
                        {this.renderEventType()}
                    </div>
                    <div className="col-12 col-md-6">
                        {this.renderEventTips()}
                    </div>
                </div>

                {/* MTI */}
                {this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content' ? (
                    <React.Fragment>
                        {/* <div className="row">
                            <div className="col-12">
                                <button
                                    className="showtix-button showtix-background__primary-1"
                                    onClick={() => this.toggleMTI()}
                                >
                                    <span>Want to use a Licensed show?</span>
                                </button>
                            </div>
                        </div> 
                        <hr className="showtix-event-details__hr" />

                        {this.renderMTI()} */}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <hr className="showtix-event-details__hr" />
                        {this.renderLicensingHouses()}
                    </React.Fragment>
                )}
                
                
                <div className="row">
                    <div className="col-12 col-lg-9">
                        <div className="row">
                            
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="name">{strings.eventName}</label>
                                    <div className="showtix-form__input">
                                        <input
                                            type="text"
                                            className="showtix-input"
                                            object="details"
                                            name="name"
                                            id="name"
                                            value={this.props.event.details.name || ''}
                                            validation="(^(?!\s*$).+)"
                                            onChange={this.props.handleChange}
                                            onBlur={this.props.validateRequiredField}
                                            required
                                        />
                                    </div>
                                    {!this.props.validation.details.name.valid &&
                                        <div className=" showtix-note error">
                                            {this.props.validation.details.name.msg}
                                        </div>
                                    }
                                </div>
                                
                            </div>
                            <div className="col-12 col-md-6">
                                <div className={"showtix-form__group " + (this.props.validation.details.contact_email.valid === false && this.props.event.details.contact_email !== '' ? 'showtix-form__error' : '')}>
                                    <label className="showtix-label" htmlFor="contact_email">{strings.contactEmail}
                                        <span id="tooltip-contactEmail" className="showtix-tooltip">!</span>
                                        <Tooltip placement="top" target="tooltip-contactEmail">
                                            {strings.contactEmailTooltip}
                                        </Tooltip>
                                    </label>
                                    <div className="showtix-form__input">
                                        <input
                                            type="text"
                                            className="showtix-input"
                                            object="details"
                                            name="contact_email"
                                            id="contact_email"
                                            value={this.props.event.details.contact_email || ''}
                                            validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                            onChange={this.props.handleChange}
                                            onBlur={this.props.validateRequiredField}
                                            required
                                        />
                                    </div>
                                    {!this.props.validation.details.contact_email.valid &&
                                        <div className=" showtix-note error">
                                            {this.props.validation.details.contact_email.msg}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="short_name">{strings.shortName}</label>
                                    <div className="showtix-form__input">
                                        <input
                                            className="showtix-input"
                                            type="text"
                                            object="details"
                                            name="short_name"
                                            id="short_name"
                                            value={this.props.event.details.short_name || ''}
                                            onChange={this.props.handleChange}
                                        />
                                    </div>
                                </div>
                                
                            </div>
                            <div className="col-12 col-md-6">
                                <div className={"showtix-form__group " + (this.props.validation.details.contact_phone.valid === false && this.props.event.details.contact_phone !== '' ? 'showtix-form__error' : '')}>
                                    <label className="showtix-label" htmlFor="contact_phone">{strings.contactPhone}
                                        <span id="tooltip-contactPhone" className="showtix-tooltip">!</span>
                                        <Tooltip placement="top" target="tooltip-contactPhone">
                                            {strings.contactPhoneTooltip}
                                        </Tooltip>
                                    </label>

                                    <div className="showtix-form__input">
                                        <input
                                            type="text"
                                            className="showtix-input"
                                            object="details"
                                            name="contact_phone"
                                            id="contact_phone"
                                            value={this.props.event.details.contact_phone || ''}
                                            validation="(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
                                            onChange={this.props.handleChange}
                                            onBlur={this.props.validateRequiredField}
                                            required
                                        />
                                    </div>
                                    {!this.props.validation.details.contact_phone.valid &&
                                        <div className=" showtix-note error">
                                            {this.props.validation.details.contact_phone.msg}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="desc">{strings.description}</label>

                                    <TextareaCount
                                        maxLength="3000"
                                        object="details"
                                        name="desc"
                                        id="desc"
                                        value={this.props.event.details.desc || ''}
                                        handleChange={this.props.handleChange}
                                    />
                                </div>
                                
                            </div>
                            
                            <div className="col-12 col-md-6">
                                {this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content' && (
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="tickets_per_user">{strings.limitOfTickets}
                                            <span id="tooltip-limitOfTickets" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-limitOfTickets">
                                                {strings.limitOfTicketsTooltip}
                                            </Tooltip>
                                        </label>

                                        <div className="showtix-form__select">
                                            <select className="showtix-input"
                                                object="details"
                                                name="tickets_per_user"
                                                id="tickets_per_user"
                                                value={this.props.event.details.tickets_per_user || ''}
                                                onChange={this.props.handleChange}
                                            >
                                                <NumericalOptions unlimited="true" start="1" end="20" />
                                            </select>
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                            <div className="col-12 col-md-6">
                                {this.props.event.details.event_type !== 'Video On Demand' && (
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="event_website">{strings.eventWebsiteUrl}
                                            <span id="tooltip-eventWebsiteUrl" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-eventWebsiteUrl">
                                                {strings.eventWebsiteUrlTooltip}
                                            </Tooltip>
                                        </label>

                                        <div className="showtix-form__input">
                                            <input
                                                className="showtix-input"
                                                type="text"
                                                object="details"
                                                name="event_website"
                                                id="event_website"
                                                value={this.props.event.details.event_website || ''}
                                                onChange={this.props.handleChange}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            {(this.props.event.details.licensing_house !== 'DPS' && this.props.event.details.licensing_house !== 'CT' && this.props.event.details.licensing_house !== 'SR' && this.props.event.details.licensing_house !== 'YP') && (
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="mti-show-yes">{strings.mtiShow}
                                            <span id="tooltip-mtiShow" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-mtiShow">
                                                {strings.mtiShowTooltip}
                                            </Tooltip>
                                        </label>

                                        <form action="">
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="mti-show-yes"
                                                    object="details"
                                                    name="mti_show"
                                                    value="true"
                                                    checked={this.props.event.details.mti_show === true}
                                                    onChange={this.props.handleChange}
                                                />
                                                <label className="showtix-label" htmlFor="mti-show-yes">{strings.mtiYes}</label>
                                            </div>
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="mti-show-no"
                                                    object="details"
                                                    name="mti_show"
                                                    value="false"
                                                    checked={this.props.event.details.mti_show === false}
                                                    onChange={this.props.handleChange}
                                                />
                                                <label className="showtix-label" htmlFor="mti-show-no">{strings.mtiNo}</label>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            )}
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="playbilder_url">{strings.playBillderUrl}
                                        <span id="tooltip-playBillderUrl" className="showtix-tooltip">!</span>
                                        <Tooltip placement="top" target="tooltip-playBillderUrl">
                                            {strings.playBillderUrlTooltip}
                                        </Tooltip>
                                    </label>

                                    <div className="showtix-form__input">
                                        <input
                                            className="showtix-input"
                                            type="text"
                                            object="details"
                                            name="playbilder_url"
                                            id="playbilder_url"
                                            value={this.props.event.details.playbilder_url || ''}
                                            onChange={this.props.handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label">{strings.serviceFee}
                                        <span id="tooltip-serviceFee" className="showtix-tooltip">!</span>
                                        <Tooltip placement="top" target="tooltip-serviceFee">
                                            {strings.serviceFeeTooltip}
                                        </Tooltip>
                                    </label>

                                    <form action="">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="fee-client"
                                                object="details"
                                                name="service_fee"
                                                value="client"
                                                checked={this.props.event.details.service_fee === 'client'}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="fee-client">{strings.feeClient}</label>
                                        </div>
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="fee-customer"
                                                object="details"
                                                name="service_fee"
                                                value="customer"
                                                checked={this.props.event.details.service_fee === 'customer'}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="fee-customer">{strings.feeCustomer}</label>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-12 col-md-6"></div>
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label">{strings.adOptOut}</label>
                                    <form action="">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="ad_opt_out-true"
                                                object="details"
                                                name="ad_opt_out"
                                                value="true"
                                                checked={this.props.event.details.ad_opt_out === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="ad_opt_out-true">{strings.optOutYes}</label>
                                        </div>
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="ad_opt_out-false"
                                                object="details"
                                                name="ad_opt_out"
                                                value="customer"
                                                checked={this.props.event.details.ad_opt_out === false}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="ad_opt_out-false">{strings.optOutNo}</label>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    {strings.tips2 && strings.tips &&
                        <div className="col-12 col-lg-3">
                            <div className="showtix-box">
                                <div className="showtix-padder">
                                    <h3 className="showtix-box__title">{strings.videoCreate.title}</h3>
                                    <p><a href={createEventUrl} target="_blank" rel="noopener">{strings.videoCreate.content}</a></p>
                                </div>	
                            </div>
                            {strings.tips.map((help, i) =>
                                <Help help={help} key={i} />
                            )}
                            {strings.tips2.map((help, i) =>
                                <Help help={help} key={i} />
                            )}
                            {this.renderHelpStream()}
                        </div>
                    }
                </div>
            </div>
        )
    }
}

Details.propTypes = {
    event: PropTypes.shape({
        details: PropTypes.shape({
            searchTerm: PropTypes.string,
            existingMitShows: PropTypes.array,
            event_type: PropTypes.string,
            contact_email: PropTypes.string,
            event_name: PropTypes.string,
            contact_phone: PropTypes.string,
            short_name: PropTypes.string,
            tickets_per_user: PropTypes.string,
            desc: PropTypes.string,
            mti_show: PropTypes.bool,
            event_website: PropTypes.string,
            service_fee: PropTypes.string,
            playbilder_url: PropTypes.string
        })
    }),
    validation: PropTypes.shape({
        details: PropTypes.shape({
            contact_email: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            event_name: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            contact_phone: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            })
        })
    }),
    handleChange: PropTypes.func,
    populateEventDetails: PropTypes.func,
    validateRequiredField: PropTypes.func,
    clearSelectedShow: PropTypes.func
}
 
export default Details;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/Details/Details.js